<template>
  <div>
    <div>
      <h5>Необходимо добавить двоих доверителей</h5>
      <fg-input :type="`text`" :label="`Имя доверителя - ${count}`" v-model="name"></fg-input>
      <fg-input v-mask="`+998#########`" :label="`Номер телефона доверителя -  ${count}`" v-model="phone"></fg-input>
    </div>
    <div class="install-control">
      <button @click="next" class="btn btn-success">{{ 'next_step' | setText('Далее') }}</button>
    </div>
  </div>
</template>
<script>
import { logger } from '../../../plugins/functions';

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0
    },
    buyer: {
      default: 0
    },
  },
  name: "filter",
  async created() {

  },
  methods: {
    next() {
      this.save();
    },
    prev() {
      this.$emit('next', this.index - 1);
    },
    save() {
      this.$loading(true);

      let dataSend = {
        phone: this.phone,
        name: this.name,
        buyer_id: this.buyer,
      };

      logger(this.$http, {
        name: 'Добавление доверителя в #PAYMART',
        description: 'Начало запроса',
        model_type: 'order',
        model_id: this.order.id
      });

      this.$http
        .post(`${this.partner['endpoint_url']}buyer/add-guarant`,
          dataSend,
          {
            headers: {
              'Authorization': `Bearer ${this.partner['api_secret_key']}`,
              'Content-Type': 'application/json'
            }
          })
        .then((response) => {
          if (response.data) {
            switch (response.data.status) {
              case 'success':
                this.message = 'Успешно добавлен';
                this.count++;
                this.name = '';
                this.phone = '+998';
                if (this.count > 2) {
                  this.$emit('next', 0);
                }
                break;
              default:
                this.message = 'Ошибка PAYMART. Номер покупателя не должен быть как у доверителя';
                break;
            }
            
            logger(this.$http, {
              name: 'Добавление доверителя в #PAYMART',
              description: this.message,
              model_type: 'order',
              model_id: this.order.id
            });
            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        })
        .catch((error) => {

          logger(this.$http, {
            name: 'Добавление доверителя в #PAYMART',
            description: 'Ошибка системы #PAYMART',
            model_type: 'order',
            model_id: this.order.id
          });
          alert('Ошибка PAYMART');
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: '',
      phone: '+998',
      name: '',
      count: 1
    };
  },
};
</script>
<style lang="scss">

</style>
